import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getNormalizedRole, targetPathForRole } from '../../utils/auth';

/** Shown inside a role layout when a nested path has no matching route. */
export default function NestedNotFound() {
  const { t } = useTranslation();
  const home = targetPathForRole(getNormalizedRole()) || '/';

  return (
    <div className="page-shell max-w-lg mx-auto">
      <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <h1 className="text-xl font-semibold text-slate-900">
          {t('common.pageNotFound', { defaultValue: 'Page not found' })}
        </h1>
        <p className="mt-2 text-sm text-slate-600">
          {t('common.pageNotFoundHint', {
            defaultValue: 'This link does not match a page in the app. Check the URL or go back home.',
          })}
        </p>
        <Link
          to={home}
          className="mt-6 inline-flex rounded-xl bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-700"
        >
          {t('common.backHome', { defaultValue: 'Back to home' })}
        </Link>
      </div>
    </div>
  );
}
